export default {
	action: '操作',
	amount: '金額',
	available_balance: '利用可能残高:',
	credit_info: 'クレジット情報',
	credit_invoice_no: 'チャージ請求書番号',
	email_bound: 'メール紐付済み',
	email_unbound: 'メール未紐付',
	pay: '支払い',
	recharge_now: 'チャージ',
	set_password_notice: 'パスワードを早めに設定してください',
	status: 'ステータス',
	unverified: '未認証',
	verified: '実名認証済み',
	view_invoice: '請求書を見る',
	welcome_back: 'おかえりなさい、',
}
